import { render, staticRenderFns } from "./exerciseList.vue?vue&type=template&id=3f1eba96&scoped=true"
import script from "./exerciseList.vue?vue&type=script&lang=js"
export * from "./exerciseList.vue?vue&type=script&lang=js"
import style0 from "./exerciseList.vue?vue&type=style&index=0&id=3f1eba96&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1eba96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f1eba96')) {
      api.createRecord('3f1eba96', component.options)
    } else {
      api.reload('3f1eba96', component.options)
    }
    module.hot.accept("./exerciseList.vue?vue&type=template&id=3f1eba96&scoped=true", function () {
      api.rerender('3f1eba96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/exam/exerciseList.vue"
export default component.exports